export default __webpack_public_path__ + "static/media/image35.83b202f6.jpg";